module.exports = __webpack_public_path__ + "i18n/ko_828fe29848acbdc917efb36d4344e178.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ko.json
// module id = a8i3
// module chunks = 154